import React, { useEffect, useRef } from 'react';
import * as d3Axis from 'd3-axis';
import { select as d3Select } from 'd3-selection';
import { ScaleLinear, ScaleTime } from 'd3';

const axisKeys = ['scale', 'ticks', 'tickArguments', 'tickValues', 'tickFormat', 'tickSize', 'tickSizeInner', 'tickSizeOuter', 'tickPadding'];
const xGridOrientations = ['Top', 'Bottom'];

export interface GridProps {
    translate: string;
    orient: 'Top' | 'Bottom' | 'Left' | 'Right';
    scale?: ScaleTime<number, number> | ScaleLinear<number, number>;
    tickSize?: number;
    tickFormat?: string;
    tickValues?: Date[];
    ticks?: number;
}

const Grid: React.FC<GridProps> = (props) => {
    const { orient, translate } = props;
    const axisElement = useRef<SVGGElement>(null);

    const renderAxis = () => {
        const axisType = `axis${orient}`;
        const axis = d3Axis[axisType]();

        for (const key in props) {
            if (axisKeys.includes(key)) {
                axis[key](props[key]);
            }
        }

        if (axisElement.current) {
            d3Select(axisElement.current!).call(axis);
        }
    };

    useEffect(() => {
        renderAxis();
    }, [props]);

    return <g className={`Grid Grid-${xGridOrientations.includes(orient) ? 'x' : 'y'}`} ref={axisElement} transform={translate} />;
};

export default Grid;
